import React from 'react';
import { Tag } from 'ui/Tag';
import { CardTagsStyle } from 'styles/components/card.styles';
import { Product } from 'pages/Totem/TotemProducts/TotemProducts.types';

export interface ProductTag {
    _id: string;
    name: string;
}

export interface ProductTagsProps {
    product: Product & {
        tags?: ProductTag[];
        isBeingTested?: boolean;
        isToBeArchived?: boolean;
    };
    cursorProp?: string;
}

export const ProductTags: React.FC<ProductTagsProps> = ({ product, cursorProp = 'default' }) => {
    const { tags, isBeingTested, isToBeArchived } = product;

    return (
        <CardTagsStyle $cursorProp={cursorProp}>
            <>
                {isBeingTested && <Tag invertColor>Testing</Tag>}
                {tags && tags.length > 0 && tags.map(({ _id, name }) => name && <Tag key={_id}>{name}</Tag>)}
                {isToBeArchived && <Tag invertColor>Bientôt plus disponible</Tag>}
            </>
        </CardTagsStyle>
    );
};
